import { render, staticRenderFns } from "./complianceActionStatus.vue?vue&type=template&id=2efb0328"
import script from "./complianceActionStatus.vue?vue&type=script&lang=js"
export * from "./complianceActionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efb0328')) {
      api.createRecord('2efb0328', component.options)
    } else {
      api.reload('2efb0328', component.options)
    }
    module.hot.accept("./complianceActionStatus.vue?vue&type=template&id=2efb0328", function () {
      api.rerender('2efb0328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/action/complianceActionStatus.vue"
export default component.exports